import { makeStyles } from '@material-ui/core';

const styles = makeStyles((_theme) => ({
  chartContainer: {
    padding: 0,
  },
  cardContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  filterContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    marginBottom: '15px',
    flexWrap: 'wrap',
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  filterLabel: {
    fontWeight: 'bold',
    marginBottom: '5px',
    fontSize: '14px',
  },
  loading: {
    textAlign: 'center',
    padding: '20px',
  },
  error: {
    color: 'red',
    padding: '10px',
    marginBottom: '10px',
  },
  filterPeriodContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '15px',
    marginBottom: '15px',
    flexWrap: 'wrap',
  },
  // Stili per il riepilogo
  summaryContainer: {
    marginTop: '30px',
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    border: '1px solid #e9ecef',
  },
  summaryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px',
    marginTop: '15px',
  },
  summaryCard: {
    backgroundColor: 'white',
    borderRadius: '6px',
    padding: '16px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    border: '1px solid #dee2e6',
  },
  summaryCardHeader: {
    marginBottom: '12px',
    borderBottom: '1px solid #e9ecef',
    paddingBottom: '8px',
  },
  summaryCardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  summaryStat: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 0',
  },
  summaryLabel: {
    fontWeight: 500,
    color: '#6c757d',
    fontSize: '14px',
  },
  summaryValue: {
    fontWeight: 'bold',
    color: '#212529',
    fontSize: '14px',
  },
}));

export default styles;
